import * as _ from "lodash";
import { ThunkResult, Utilities } from "../../../shared/utilities";
import { saveProcessFailed, savingProcess } from "../../actions/SaveProcess";
import { State } from "../../model/State";

export function requestAndRedirect(env: string | undefined, agentName: string | undefined, id: number, triggerData: any): ThunkResult<void, State> {
    return async (dispatch) => {
        let count = 0;
        dispatch(savingProcess());
        const result = await Utilities.postJsonAndParseResponse<string[]>(`api/processList/runOnce/${env}/${agentName}`, [{ id: id, triggerData: triggerData }])
            .catch((e) => console.error("Could not process runOnce request " + e));
        async function poll() {
            try {
                // When details has been populated navigate to process instance details view
                await Utilities.getFetch(`api/details/${env}/${(result as string[])[0]}`);
                Utilities.navigateTo(`ProcessInstance/Instance/${(result as string[])[0]}?environmentName=${env}`);
            } catch {
                // Wait until process instance details has been populated
                count++;
                if (count >= 20) {
                    Utilities.toastError("Could not find process execution after 20 seconds. Is the agent running?");
                    dispatch(saveProcessFailed());
                } else {
                    setTimeout(() => poll(), 1000);
                }
            }
        }
        // Initially poll process instance details
        setTimeout(() => poll(), 1000);
    };
}
